<template>
  <div class="container bottom-fix-padding">
    <v-suburb v-show="returnSuburbIf" @change="changeReturnSuburb" @close="returnClose()"></v-suburb>
    <v-datepicker v-show="ifDateReturn" outer_opendate="90"  :outer_disableddates="return_disabledDate" :outer_date="orderDetail.details.return_date" :outer_period="orderDetail.details.return_period" @change="returnDateSave" @close="returnDateClose()"></v-datepicker>
    <div class="core" v-show="!returnSuburbIf&&!ifDateReturn">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/storage/order-detail?id='+$route.query.id)"></span>
      </div>
      <div class="title">送回详情补充</div>

      <div class="main">
          <div class="core">

            <div class="weui-cells__title">送回日期</div>
            <div class="weui-cells">
              <a class="weui-cell weui-cell_access" href="javascript:;" @click="returnDateOpen()">
                  <div class="weui-cell__bd">
                      <p>送回日期</p>
                  </div>
                  <div class="weui-cell__ft" v-if="!orderDetail.details.return_date">点击选择日期</div>
                  <div class="weui-cell__ft" v-else>{{orderDetail.details.return_date | moment("YYYY年M月D日")}} {{return_period}}</div>
              </a>
            </div>
            <div class="weui-cells__title big to-return">送回地址</div>
              <div class="weui-cells weui-cells_form" >
                  <div class="weui-cell">
                      <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                      <div class="weui-cell__bd">
                          <input class="weui-input" type="text" placeholder="如: Unit 2, 9 Hunter St" v-model="orderDetail.details.return_address.return_street" :disabled="ifAlreadyAddr">
                      </div>
                  </div>
                  <div class="weui-cell weui-cell_access padding-fix" @click="returnSelect()">
                      <div class="weui-cell__hd">
                          <label class="weui-label">Suburb</label>
                      </div>
                      <div class="weui-cell__bd" v-if="orderDetail.details.return_address.return_suburb==''"> 
                          <p class="placeholder-color">如: Chatswood</p>
                      </div>
                      <div class="weui-cell__bd" v-if="orderDetail.details.return_address.return_suburb!=''"> 
                          <p>{{orderDetail.details.return_address.return_suburb}}</p>
                      </div>
                      <div class="weui-cell__ft"></div>
                  </div>
                  <div class="weui-cell weui-cell_select weui-cell_select-after">
                      <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                      <div class="weui-cell__bd">
                          <select class="weui-select" name="select2" >
                              <option value="NSW" selected>NSW</option>
                          </select>
                      </div>
                  </div>
                  <div class="weui-cell" >
                      <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                      <div class="weui-cell__bd">
                          <input class="weui-input" type="text"  placeholder="如：2000" v-model="orderDetail.details.return_address.return_postcode" :disabled="ifAlreadyAddr">
                      </div>
                  </div>
            </div>
        </div>

      </div>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="submitOrder()" >保存信息</div>
        </div>
      </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在连接中</p>
            </div>
        </div>
    </transition>
    <img :src="pixelURL('storage','orderUpdate')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'step3',
  data () {
    return {
      orderDetail:{
        "order_id": "",
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "gst_amount": "",
        "cancelfee_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": "",
        "other_amount_data": "",
        "invoices_url": "",
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
            "operates_num": 0
        },
        "details": {
            "student_plan": "",
            "baggage": "",
            "pick_address": {
                "pick_street": "",
                "pick_suburb": "",
                "pick_state": "",
                "pick_postcode": ""
            },
            "pick_date": "",
            "pick_time": "",
            "pick_period": "",
            "return_address": {
                "return_street": "",
                "return_suburb": "",
                "return_state": "",
                "return_postcode": ""
            },
            "return_date": "",
            "return_time": "",
            "return_period": "",
            "contact_bak": "",
            "return_pending": "",
            "student_plan_name": ""
        },
        "expiration_time": 0,
        "lifecycle_text": "",
        "lifecycle_status": 0
      },
      isSending:false,
      ifDateReturn:false,
      returnSuburbIf:false,
      ifUpgradePlan:false,
      localError:[],
      localErrorShow:false,
      ifAlreadyAddr:false,
      ifAlreadyDate:false,
      return_disabledDate: {
        to: new Date(),
      },
    }
  },
  created: function () {
    if(!this.checkLogin()){
        this.$router.push('/order');
    }
    document.querySelector("html").classList.add("grey-background");
    this.getData();
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  computed: {
    pick_period: function () {
      let result = '';
      switch (this.orderDetail.details.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.orderDetail.details.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
  },
  methods: {
    allFilled(){
       if(this.orderDetail.details.username &&
          this.orderDetail.details.userphone &&
          this.orderDetail.details.pick_date &&
          this.orderDetail.details.baggage){
            return true;
        }
    },
    checkSubmit(){
      this.localError = [];
      if (!this.orderDetail.details.pick_date) {
        this.localError.push("请选择取货时间");
      }
      if (!this.localError.length) {
        this.orderUpdateAll('/storage-step4');
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    returnDateClose(){
      this.ifDateReturn = false;
      document.querySelector("html").classList.add("grey-background");
    },
    returnDateOpen(){
      if(this.ifAlreadyDate){
        return false;
      }
      else{
        this.ifDateReturn = true;
        document.querySelector("html").classList.remove("grey-background");
      }
    },
    returnDateSave(date,period){
      this.returnDateClose();
      this.orderDetail.details.return_date = date;
      this.orderDetail.details.return_period= period;
    },
    changeReturnSuburb: function(suburb,postcode) {
        this.orderDetail.details.return_address.return_suburb = suburb;
        this.orderDetail.details.return_address.return_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
    returnClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
    returnSelect: function() {
        if(this.ifAlreadyAddr){
          return false;
        }
        else{
          this.rememberTop = window.scrollY;
          this.returnSuburbIf=true;
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }
    },
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            if(that.orderDetail.lifecycle_status==1){
              that.$router.push('/order-cancel?reason=timeout');
            }
            if(that.orderDetail.order_status==8){
              that.$router.push('/order-cancel');
            }
            if(that.orderDetail.pay_status==0||that.orderDetail.pay_status==1){
            }
            if(that.orderDetail.details.return_address.return_street){
              that.ifAlreadyAddr = true;
            }
            if(that.orderDetail.details.return_date){
              that.ifAlreadyDate = true;
            }
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    submitOrder(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject = {};

        orderObject.token = localStorage.token;
        orderObject.order_number = this.$route.query.id;
        orderObject.return_date = this.orderDetail.details.return_date;
        if(orderObject.return_date){
          orderObject.return_date = new Date(orderObject.return_date);
          orderObject.return_date = Vue.filter('moment')(orderObject.return_date,"YYYY-MM-DD");
        }
        if(this.orderDetail.type_id=='1550735973'){
          orderObject.jump_type = 2;
        }
        if(this.orderDetail.type_id=='1550735972'){
          orderObject.jump_type = 1;
        }

        orderObject.return_period = this.orderDetail.details.return_period;
        orderObject.return_street = this.orderDetail.details.return_address.return_street;
        orderObject.return_suburb = this.orderDetail.details.return_address.return_suburb;
        orderObject.return_postcode = this.orderDetail.details.return_address.return_postcode;

        if(orderObject.return_street || orderObject.return_suburb || orderObject.return_postcode){
          orderObject.return_state = 'NSW';
        }

        console.log(orderObject)

        this.axios.post(this.apiURL()+'/details/Storage/setStorageAddress', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            alert("保存成功，即将返回订单详情页");
            that.$router.push('/order-detail?id='+that.$route.query.id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/storage/order-update.vue